'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const MaintainRepairIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M10.3 12.9L17.5 20C17.9 20.4 18.5 20.4 18.9 20L20.1 18.8C20.5 18.4 20.5 17.8 20.1 17.4L13 10.2C13.3 9.39999 13.5 8.49999 13.3 7.59999C13 5.59999 11.4 3.89999 9.29998 3.49999C8.39998 3.39999 7.59998 3.49999 6.79998 3.79999L8.69998 5.69999C9.49998 6.49999 9.59998 7.79999 8.89998 8.59999C8.09998 9.59999 6.59998 9.59999 5.69998 8.79999L3.69998 6.79999C3.49998 7.59999 3.39998 8.39999 3.59998 9.29999C3.99998 11.3 5.59998 12.9 7.69998 13.3C8.59998 13.4 9.49998 13.3 10.3 12.9Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpMaintainRepairIcon = forwardRef(MaintainRepairIcon);

export { VpMaintainRepairIcon as default };
